import { useId } from "react";

export function Switch({
  checked,
  onCheckedChange,
  label,
  description,
  disabled = false,
}: {
  checked: boolean;
  onCheckedChange(checked: boolean): void;
  label: string;
  description?: string;
  disabled?: boolean;
}) {
  const id = useId();
  return (
    <div className="flex items-center justify-between gap-4 rounded-[var(--pl-radius-xs)] border border-[var(--pl-line)] bg-[var(--pl-surface)] px-3 py-3">
      <div
        id={`${id}-label`}
        className="min-w-0 cursor-pointer"
        onClick={() => !disabled && onCheckedChange(!checked)}
      >
        <span className="block text-sm font-medium text-[var(--pl-text)]">{label}</span>
        {description ? (
          <span className="mt-0.5 block text-xs leading-5 text-[var(--pl-muted)]">
            {description}
          </span>
        ) : null}
      </div>
      <button
        id={id}
        type="button"
        role="switch"
        aria-labelledby={`${id}-label`}
        aria-checked={checked}
        disabled={disabled}
        data-state={checked ? "checked" : "unchecked"}
        onClick={() => onCheckedChange(!checked)}
        className="relative !inline-flex !h-6 !min-h-0 !w-11 shrink-0 cursor-pointer !rounded-full !border !border-[var(--pl-line-strong)] !bg-[var(--pl-surface-2)] !p-0 !text-transparent transition-colors duration-200 hover:!brightness-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--pl-primary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--pl-bg)] disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:!border-[var(--pl-primary)] data-[state=checked]:!bg-[var(--pl-primary)]"
      >
        <span
          className={`pointer-events-none absolute top-0.5 h-[18px] w-[18px] rounded-full bg-white shadow-sm transition-[left] duration-200 ${checked ? "left-[21px]" : "left-0.5"}`}
        />
      </button>
    </div>
  );
}
